import { BoxProps, Code, Flex, IconButton } from '@chakra-ui/react';
import React, { useCallback } from 'react';

import { MODIFIER_KEY } from 'config/shortcuts';
import SearchIcon from 'vectors/Search';

interface Props {
  isDisabled?: boolean;
  width?: BoxProps['width'];
}

const SearchBar: React.FC<Props> = ({ isDisabled, width }) => {
  const onClick = useCallback(() => {}, []);

  return (
    <IconButton
      variant="outline"
      aria-label="Search"
      justifyContent="flex-end"
      data-testid="nav-search"
      onClick={!isDisabled ? onClick : undefined}
      role="group"
      size="xs"
      width={width ?? '150px'}
      borderColor="border.light"
      _hover={{
        backgroundColor: 'button.secondary.hover',
      }}
    >
      <Flex justifyContent="space-between" width="full" alignItems="center" px={1}>
        <SearchIcon color="icon.secondary" />
        <Code
          fontSize="xxs"
          wordBreak="break-all"
          height="16px"
          borderRadius="base"
          p={1}
          border="1px solid"
          borderColor="border.light"
          display="flex"
          alignItems="center"
          bgColor="inherit"
          color="text.secondary"
        >
          {MODIFIER_KEY}K
        </Code>
      </Flex>
    </IconButton>
  );
};

export default SearchBar;
